import { APIResponseType } from 'app/apiService/types';
import apiService from '..';

export interface CreateShortUrlRequest {
  emailAddress: string;
  opportunityId: string;
  dealerId: string;
  analytics?: boolean;
  originating_dealer_id?: string;
  attribution_type?: string;
  date_of_attribution?: string;
}

export interface CreateShortUrlResponse {
  statusCode: number;
  message: string;
  statusText: string;
  body: {
    shortUrl: string;
    details: {
      emailAddress: string;
      opportunityId: string;
      dealerId: string;
      originating_dealer_id?: string;
      attribution_type?: string;
      date_of_attribution?: string;
    };
  };
}

const ATTRIBUTION_HISTORY_TYPES = new Set([
  'SOLD',
  'CONTACTED',
  'LEAD_SOLD',
  'LEAD_CONTACTED',
]);

export function attributionHistoryHintsFromRow(
  row?: Record<string, unknown> | null,
): Pick<CreateShortUrlRequest, 'attribution_type' | 'date_of_attribution'> {
  if (!row) {
    return {};
  }
  const rawType = row.attribution_type ?? row.nurturing_status;
  const rawDate =
    row.date_of_attribution ??
    row.latest_sold_date ??
    row.date_sold ??
    row.latest_contacted_date ??
    row.date_contacted;
  const hints: Pick<
    CreateShortUrlRequest,
    'attribution_type' | 'date_of_attribution'
  > = {};
  if (rawType != null && ATTRIBUTION_HISTORY_TYPES.has(String(rawType).trim().toUpperCase())) {
    hints.attribution_type = String(rawType).trim();
  }
  if (rawDate != null && String(rawDate).trim()) {
    hints.date_of_attribution = String(rawDate).trim();
  }
  return hints;
}

class NurturingHistory {
  static ENDPOINT = 'api/v2/nurturing/history';

  static async createShortUrl(payload: CreateShortUrlRequest): Promise<APIResponseType<CreateShortUrlResponse>> {
    try {
      const response = await apiService.post<CreateShortUrlResponse>(
        `${this.ENDPOINT}/short-url`,
        payload,
        {},
        false // Disable caching for this operation
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static extractUrlId(shortUrl: string): string | null {
    try {
      // Extract ID from URL like "https://app.myautoiq.net/url/6862c7e2868e70732edda356"
      const match = shortUrl.match(/\/url\/([^/?]+)/);
      return match ? match[1] : null;
    } catch (error) {
      console.error('Error extracting URL ID:', error);
      return null;
    }
  }

  static buildRedirectUrl(urlId: string): string {
    // Use the current domain instead of API URL
    const currentDomain = window.location.origin;
    return `${currentDomain}/url/${urlId}`;
  }
}

export default NurturingHistory; 